/* eslint-disable react/display-name */
import { WellListWidgetWrapper } from 'src/pages/dashboard/features/well-list-widget/WellListWidget';
import type { WellListWidgetEntity } from 'src/pages/dashboard/features/well-list-widget/WellListWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderWellListWidget(widget: WellListWidgetEntity, options: TWidgetRendererOptions): TRenderWidget {
  return ({ onCreateWellsFilterWidget, onCreateWellLogsWidget }) => (
    <WellListWidgetWrapper
      wellListEntity={widget}
      options={options}
      onCreateWellsFilterWidget={onCreateWellsFilterWidget}
      onCreateWellLogsWidget={onCreateWellLogsWidget}
    />
  );
}
